import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PartnerDashboard = () => {
  return (
    <>
      <div className="home">
        <Header />
        <div id="page" className="hfeed page-wrapper">

          <div id="site-main" className="site-main">
            <div id="main-content" className="main-content">
              <div id="primary" className="content-area">
                <div id="content" className="site-content" role="main">
                  <div className="section-padding">
                    <div className="section-container p-l-r">
                      <div className="container py-5 dashboard">
                        <div className="row justify-content-center">
                          {/* Box 1 */}
                          <div
                            className="col-md-6 col-lg-6 mb-4"
                            id="dashboard-box"
                            style={{ margin: "10px 0" }}
                          >
                            <a href="/partneraccount">
                              <div className="custom-box">
                                <div>
                                  <img src="./assets/img/account.png" alt="Account" />
                                </div>
                                <div className="custom-header">My Account</div>
                                <div className="custom-paragraph">
                                  Open or edit account details
                                </div>
                              </div>
                            </a>
                          </div>
                          {/* Box 2 */}
                          <div
                            className="col-md-6 col-lg-6 mb-4"
                            id="dashboard-box"
                            style={{ margin: "10px 0" }}
                          >

                            <a href="/orders">
                              <div className="custom-box">
                                <div>
                                  <img src="./assets/img/orders.png" alt="Orders" />
                                </div>
                                <div className="custom-header">Omnichannel Orders </div>
                                <div className="custom-paragraph">
                                  Track your past & current Omnichannel orders
                                </div>
                              </div>
                            </a>
                          </div>
                          {/* Box 3 */}
                          <div
                            className="col-md-6 col-lg-6 mb-4"
                            id="dashboard-box"
                            style={{ margin: "10px 0" }}
                          >
                            <a href="/customiseorder">
                              <div className="custom-box">
                                <div>
                                  <img src="assets/img/orders.png" alt="Address" />
                                </div>
                                <div className="custom-header">Existing Custom Orders</div>
                                <div className="custom-paragraph">Track your past and current Custom orders here</div>
                              </div>
                            </a>
                          </div>
                          {/* Box 4 */}



                          <div
                            className="col-md-6 col-lg-6 mb-4"
                            id="dashboard-box"
                            style={{ margin: "10px 0" }}
                          >
                            <a href="/customiseproduct">
                              <div className="custom-box">
                                <div>
                                  <img src="./assets/img/createcustomorder.png" alt="Orders" style={{width:32}} />
                                </div>
                                <div className="custom-header">Create New Custom Order</div>
                                <div className="custom-paragraph">
Custom Order
                                </div>
                              </div>
                            </a>
                          </div>
                          <div
                            className="col-md-6 col-lg-6 mb-4"
                            id="dashboard-box"
                            style={{ margin: "10px 0" }}
                          >
                            <a href="/requestforpriceview">
                              <div className="custom-box">
                                <div>
                                  <img src="./assets/img/pricerequest.png" alt="Delivery" />
                                </div>
                                <div className="custom-header">Price Request </div>
                                <div className="custom-paragraph">
                                  Request For Any Modification
                                </div>
                              </div>
                            </a>
                          </div>
                          <div
                            className="col-md-6 col-lg-6 mb-4"
                            id="dashboard-box"
                            style={{ margin: "10px 0" }}
                          >
                            <a href="/stockcarryorder">
                              <div className="custom-box">
                                <div>
                                  <img src="assets/img/stockandcarry.png" alt="Delivery" />
                                </div>
                                <div className="custom-header">Stock & Carry </div>
                                <div className="custom-paragraph">
                                 Stock & Carry
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
        <Footer />
      </div>
    </>
  );
};

export default PartnerDashboard;
